<template>
  <div style="display: inline-block;">
    <auth-button :opt="opt" :label="buttonText" :icon="hasIcon ? 'el-icon-plus' : ''" @click.native="handleBatchAdd" :plain="plain"></auth-button>
    <dialog-info :title="dialogTitle" :visible.sync="showBatchAddDialog" :confirmLoading="batchAddLoading" @confirm="submitBatchAdd">
      <div class="import-tip">导入须知：请下载{{buttonText}}模板，按照模板输入，每次导入不超过{{limitNum}}个</div>
      <div class="import-tip import-other-tip" v-for="(item, index) in otherTips" :key="index">{{item}}</div>
      <auth-button :opt="opt" label="批量导入" @click.native="getMultiFiles" size="small" class="import"></auth-button>
      <a :href="'static/' + templateName + '.xlsx'" class="downloadLink">下载模板文件</a>
      <input type="file" ref="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      <p>仅支持.xls、.xlsx格式</p>
      <el-col v-if="multiFileName !== ''" class="hasSelect">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
    </dialog-info>

    <dialog-info :title="dialogTitle + '结果'" :visible.sync="showBatchResultDialog" :showCancelBtn="false" :showConfirmBtn="false">
      <p class="add-info">已成功{{resultTitle}}{{successNum}}个{{typeName}}，以下{{failNum}}个{{typeName}}{{resultTitle}}失败<span v-show="failNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
      <el-table class="table" border :data="failList" v-loading="searchLoading">
          <el-table-column
            v-for="item in tableList"
            :label="item.label"
            :prop="item.prop"
            :key="item.prop">
          </el-table-column>
      </el-table>
    </dialog-info>

    <dialog-info title="批量配置提示" :visible.sync="showConfirmDialog" :confirmLoading="confirmLoading" @confirm="batchSubmit" :dialogWidth="650" footerAlign="center">
      <div class="confirm-tips">请再次核实清楚商户的额度包</div>
      <div style="line-height: 32px;">在同一额度包周期中，已有相同结算卡的商户配置了额度包，商户名单如下</div>
      <el-table class="table" border :data="confirmList">
        <el-table-column
          v-for="item in validTableList"
          :label="item.label"
          :prop="item.prop"
          :key="item.prop">
        </el-table-column>
      </el-table>
    </dialog-info>
  </div>
</template>
<!--    目前仅支持上传表格-->
<script>
import dialogInfo from '@/components/layout/dialogInfo'
export default {
  name: 'BatchImport',
  components: {
    dialogInfo
  },
  props: {
    // 导入按钮文本
    buttonText: {
      type: String,
      default: '批量添加'
    },
    // 提交接口
    submitName: {
      type: String,
      default: 'batchInputInvoice'
    },
    templateName: {
      type: String,
      default: '批量添加银行模板'
    },
    dialogTitle: {
      type: String,
      default: '批量添加'
    },
    tableList: {
      type: Array,
      default: () => []
    },
    typeName: {
      type: String,
      default: '银行'
    },
    failKey: {
      type: String,
      default: 'failBanks'
    },
    opt: {
      type: String,
      default: 'batch_add'
    },
    otherData: {
      type: Object,
      default: () => {}
    },
    plain: {
      type: Boolean,
      default: false
    },
    hasIcon: {
      type: Boolean,
      default: true
    },
    limitNum: {
      type: Number,
      default: 500
    },
    resultTitle: {
      type: String,
      default: '添加'
    },
    needValid: {
      type: Boolean,
      default: false
    },
    validApi: {
      type: String,
      default: ''
    },
    validTableList: {
      type: Array,
      default: () => []
    },
    otherTips: {
      type: Array,
      default: () => []
    },
    searchLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      multiFile: '', // 批量上传的文件
      buttonLoading: false, // 提交按钮加载
      showBatchAddDialog: false, // 导入弹窗
      successNum: 0, // 成功条数
      failNum: 0, // 失败条数
      failData: [], // 失败详细信息
      showBatchResultDialog: false, // 批量导入结果
      multiFileName: '', // 批量文件名
      batchAddLoading: false,
      showConfirmDialog: false,
      confirmLoading: false,
      confirmList: [],
      failList: []
    }
  },
  methods: {
    /**
             * @description 批量录入
             */
    handleBatchAdd () {
      this.buttonLoading = false
      this.showBatchAddDialog = true
      this.multiFile = ''
      this.multiFileName = ''
    },
    /**
           * @description 上传文件
           */
    getMultiFiles () {
      this.$refs.file.click()
    },
    /**
             * @description 删除已上传文件
             */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
             * @description 选择文件
             */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    submitBatchAdd () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      // console.log(111222, this.otherData)
      this.batchAddLoading = true
      if (this.needValid) {
        const data = new FormData()
        // for (const key in this.otherData) {
        //   data.append(key, this.otherData[key])
        // }

        if (this.otherData) {
          // 解决sonar问题：for in循环会遍历原型链上的属性
          Object.keys(this.otherData).forEach(key => {
            data.append(key, this.otherData[key])
          })
        }
        data.append('multipartFile', this.multiFile)
        this.$axios.post(this.$api[this.validApi], data).then((res) => {
          this.batchAddLoading = false
          if (parseInt(res.respCode) === 0) {
            if (res.data.length === 0) {
              this.batchSubmit()
            } else {
              this.confirmList = res.data.map(item => {
                if (item.quotaSum) {
                  item.quotaSum = (item.quotaSum / 100).toFixed(2)
                }
                return item
              })
              this.showConfirmDialog = true
            }
          }
        })
      } else {
        this.batchSubmit()
      }
    },
    batchSubmit () {
      this.showConfirmDialog = false
      this.batchAddLoading = true
      const data = new FormData()
      // for (const key in this.otherData) {
      //   data.append(key, this.otherData[key])
      // }
      if (this.otherData) {
        // 解决sonar问题：for in循环会遍历原型链上的属性
        Object.keys(this.otherData).forEach(key => {
          data.append(key, this.otherData[key])
        })
      }
      data.append('multipartFile', this.multiFile)
      this.$axios.post(this.$api[this.submitName], data).then((res) => {
        this.batchAddLoading = false
        if (parseInt(res.respCode) === 0) {
          this.successNum = res.data.successCount
          this.showBatchAddDialog = false
          if (res.data.failCount === 0) {
            this.$message({
              showClose: true,
              message: res.respMsg + '，成功导入' + res.data.successCount + '条',
              type: 'success'
            })
          } else {
            this.failNum = res.data.failCount
            this.failList = res.data[this.failKey]
            this.showBatchResultDialog = true
          }
          this.$emit('submit', this.successNum !== 0)
        }
      }).catch(() => {
        this.batchAddLoading = false
        this.$emit('submit', false)
      })
    },
    jumpDownload () {
      this.showBatchResultDialog = false
      this.$store.dispatch('delVisitedViews', {
        path: '/fileManage/downloadCenter'
      }).then(() => {
        this.$router.push('/fileManage/downloadCenter')
      })
    }
  }
}
</script>

<style scoped lang="less">
.hasSelect{
  font-size: 15px;
  margin-top: 20px;
}
.hasSelect span{
  float: left;
  margin-bottom: 20px;
  line-height: 30px;
  display: block;
  max-width: 430px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hasSelect .removeIcon{
  color:#F56C6C;
  line-height: 30px;
  cursor: pointer;
  margin-left: 10px;
}
.tips{
  margin: 0;
  margin-bottom: 20px;
  font-size: 14px;
  color: #acacac;
  line-height: 20px;
}
.check {
  margin-left:5px
}
.import-tip {
  color: #A3A3A4;
  font-size: 12px;
  margin-bottom: 20px;
}
.import-other-tip{
  margin-left:60px;
}

.import {
  /deep/ .el-button {
    width: 100px;
    height: 30px;
    text-align: center;
    padding: 0;
    margin: 0 12px 12px 0;
  }
}
.add-info {
  font-size: 12px;
  padding-bottom: 8px;
}
.confirm-tips {
  color: red;
  margin-top: -10px;
  margin-bottom: 10px;
}
</style>
